import {
  ChatListRequest,
  ChatListResponse,
  ChatMessageListResponse,
  GetChatRequest,
  SendMessageRequest,
} from "@/types/chatRoomTypes";
import {createApi, FetchArgs} from "@reduxjs/toolkit/query/react";
import platformAuthConfig from "./platformConfig";

const chatApi = createApi({
  reducerPath: "chatApi",
  ...platformAuthConfig(),
  tagTypes: ["Chats", "ChatMessages"],
  endpoints: (builder) => ({
    getChats: builder.query<ChatListResponse, ChatListRequest>({
      query: (config): FetchArgs => ({
        url: `/${config.org_id}/conversation/${config.campaign_id}/list_conversation`,
        method: "GET",
      }),
      providesTags: ["Chats"],
    }),
    getChatMessages: builder.query<ChatMessageListResponse, GetChatRequest>({
      query: (config): FetchArgs => ({
        url: `/${config.org_id}/conversation/${config.campaign_id}/${config.chat_id}`,
        method: "GET",
      }),
      providesTags: ["ChatMessages"],
    }),
    sendChatMessages: builder.mutation<ChatListResponse, SendMessageRequest>({
      query: (config): FetchArgs => ({
        url: `/${config.org_id}/conversation/${config.campaign_id}/send_message_manually/${config.chat_id}`,
        method: "PUT",
        body: config,
      }),
      invalidatesTags: ["ChatMessages"],
    }),
    deleteChat: builder.mutation<void, GetChatRequest>({
      query: (config): FetchArgs => ({
        url: `/${config.org_id}/conversation/${config.campaign_id}/${config.chat_id}`,
        method: "DELETE",
      }),
      invalidatesTags: ["Chats"],
    }),
    closeChat: builder.mutation<void, GetChatRequest>({
      query: (config): FetchArgs => ({
        url: `/${config.org_id}/conversation/${config.campaign_id}/close/${config.chat_id}`,
        method: "PUT",
      }),
      invalidatesTags: ["Chats"],
    }),
    changeChatStatus: builder.mutation<void, GetChatRequest>({
      query: (config): FetchArgs => ({
        url: `/${config.org_id}/conversation/${config.campaign_id}/update_status/${config.chat_id}/${config.status}`,
        method: "PUT",
      }),
      invalidatesTags: ["Chats"],
    }),
  }),
});

export const {
  useGetChatsQuery,
  useGetChatMessagesQuery,
  useSendChatMessagesMutation,
  useDeleteChatMutation,
  useCloseChatMutation,
  useChangeChatStatusMutation,
  useLazyGetChatMessagesQuery,
} = chatApi;

export default chatApi;
